import Form, { FormItemProps } from 'antd/lib/form';
import { PjmRegistrationFormState } from './usePjmRegistrationFormState';
import React from 'react';

type FormItemControlProps = { formState: PjmRegistrationFormState } & FormItemProps;
export function FormItemControl({ formState, children, ...args }: FormItemControlProps) {
    const nameKey = args.name?.join('.') as keyof PjmRegistrationFormState;

    const isHidden = formState[nameKey]?.state === 'hidden';
    const isDisabled = formState[nameKey]?.state === 'disabled';

    if (isHidden) {
        return null;
    }

    return (
        <Form.Item {...args}>
            {
                // @ts-expect-error
                React.cloneElement(children, { disabled: isDisabled })
            }
        </Form.Item>
    );
}
